"use strict";

/**
 * HashScroller
 * Automatically scrolls to elements when the URL hash changes.
 * Accounts for sticky headers and CSS scroll-margin-top.
 */
export class HashScroller {
    #siteHeader;

    constructor(args) {
        const headerSelector = args.headerSelector ?? 'header';

        this.#siteHeader = document.querySelector(headerSelector);

        this.bind();
        this.checkInitialHash();
    }

    bind() {
        window.addEventListener('hashchange', this.onHashChange);
    }

    /**
     * Checks if a hash exists on initial load and scrolls to it.
     */
    checkInitialHash() {
        if (window.location.hash) {
            // Use requestAnimationFrame to ensure the DOM is settled
            window.requestAnimationFrame(() => {
                this.scrollTo(window.location.hash);
            });
        }
    }

    onHashChange = (event) => {
        const hash = window.location.hash;
        
        if (hash) {
            window.requestAnimationFrame(() => {
                this.scrollTo(hash);
            });
        }
    }

    /**
     * Performs the scroll calculation and animation.
     * @param {string} hash - The ID selector to scroll to.
     */
    scrollTo(hash) {
        const target = document.getElementById(hash.replace(/^#/, ''));

        if (!target) {
            return;
        }

        let effectiveHeaderHeight = 0;
        if (this.#siteHeader) {
            const bottomBar = this.#siteHeader.querySelector('.bottom-bar');
            // If the main header has the 'scrolling' class and the bottom bar exists, use the bottom bar's height.
            // Otherwise, use the full header's height.
            if (this.#siteHeader.classList.contains('scrolling') && bottomBar) {
                effectiveHeaderHeight = bottomBar.offsetHeight;
            } else {
                effectiveHeaderHeight = this.#siteHeader.offsetHeight;
            }
        }

        const headerHeight = effectiveHeaderHeight;
        const scrollMarginTop = parseInt(window.getComputedStyle(target).scrollMarginTop) || 0;
        const targetOffset = target.getBoundingClientRect().top + window.pageYOffset;

        const finalPosition = targetOffset - headerHeight - scrollMarginTop;

        window.scrollTo({
            top: finalPosition,
            behavior: 'smooth'
        });
    }
}